import { Bug, FileText, HelpCircle, Lightbulb, Mail } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function HelpMenu() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          intent="secondary"
          size="sm"
          className="font-normal"
        >
          <HelpCircle size={16} />
          Help
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" align="start" sideOffset={8}>
        <DropdownMenuItem
          onSelect={() => window.open("mailto:hello@exec.com", "_blank")}
        >
          <Mail className="mr-2" size={16} />
          Contact Exec
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => window.open("mailto:ideas@exec.com", "_blank")}
        >
          <Lightbulb className="mr-2" size={16} />
          Request Feature
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => window.open("mailto:bugs@exec.com", "_blank")}
        >
          <Bug className="mr-2" size={16} />
          Report Bug
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/updates" className="text-inherit flex items-center">
            <FileText className="mr-2" size={16} />
            Product Updates
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
